export default __webpack_public_path__ + "static/media/ibrahim_shqair.20dfda1f.jfif";